import React, { useState } from "react";
import AnalysisFieldCard from "./AnalysisFieldCard";
import {
  collectFieldResults,
  hasUsefulContent,
  isSectionOutOfScope,
  shouldShowField,
} from "./analysisUtils";

export default function AnalysisSection({
  title,
  node,
  pathPrefix,
  language,
  showOutOfScope,
  onEvidenceClick,
  defaultCollapsed = false,
  muted = false,
  getFieldLabel,
}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const fields = collectFieldResults(node, pathPrefix);
  const outOfScope = isSectionOutOfScope(fields);
  const useful = hasUsefulContent(fields);

  if (!fields.length) return null;
  if (outOfScope && !showOutOfScope) return null;
  if (!useful && !showOutOfScope) return null;

  const visibleFields = fields.filter(({ result }) => shouldShowField(result, showOutOfScope));
  if (!visibleFields.length) return null;

  const sectionMuted = muted || (outOfScope && showOutOfScope);

  return (
    <section className="space-y-3">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 text-left"
        onClick={() => setCollapsed((v) => !v)}
      >
        <h3
          className={`text-base font-semibold ${
            sectionMuted ? "text-slate-500 dark:text-slate-400" : "text-slate-800 dark:text-slate-100"
          }`}
        >
          {title}
          {outOfScope && showOutOfScope ? (
            <span className="ml-2 text-xs font-normal text-slate-400">(out of scope)</span>
          ) : null}
        </h3>
        <span className="text-slate-400">{collapsed ? "▸" : "▾"}</span>
      </button>
      {!collapsed && (
        <div className="grid items-start gap-3 sm:grid-cols-2">
          {visibleFields.map(({ fieldId, result }) => (
            <AnalysisFieldCard
              key={fieldId}
              fieldId={fieldId}
              result={result}
              language={language}
              muted={sectionMuted}
              onEvidenceClick={onEvidenceClick}
              labelOverride={getFieldLabel ? getFieldLabel(fieldId) : undefined}
            />
          ))}
        </div>
      )}
    </section>
  );
}
